import { useTranslation } from "react-i18next";

/**
 * Skip-to-content link for keyboard & screen reader users.
 * Required by BITV 2.0 / WCAG 2.1 AA (2.4.1 Bypass Blocks).
 * Visually hidden until focused.
 */
const SkipLink = () => {
  const { t } = useTranslation();
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:text-sm focus:font-medium focus:outline-none focus:ring-2 focus:ring-ring"
    >
      {t("skipLink")}
    </a>
  );
};

export default SkipLink;
